import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

import { LanguageService } from './language.service';

export const initializeTranslations = () => {
  const translate = inject(TranslateService);
  const language = inject(LanguageService);

  return firstValueFrom(translate.use(language.language()));
};
